import React, { useState, useRef } from 'react'
import './ImageMagnifier.css'

const ImageMagnifier = ({ imageUrl, zoom, magnifierSize = 200 }) => {
  const containerRef = useRef(null)

  const [position, setPosition] = useState({ x: 0, y: 0 })
  const [showMagnifier, setShowMagnifier] = useState(false)

  const handleMouseHover = e => {
    const container = containerRef.current
    const rect = container.getBoundingClientRect()

    const x = e.clientX - rect.left
    const y = e.clientY - rect.top

    const xPercent = (x / rect.width) * 100
    const yPercent = (y / rect.height) * 100

    setPosition({ x, y, xPercent, yPercent })
  }
  return (
    <div
      ref={containerRef}
      className={`img-magnifier-container ${showMagnifier ? 'zooming' : ''}`}
      onMouseEnter={() => setShowMagnifier(true)}
      onMouseLeave={() => setShowMagnifier(false)}
      onMouseMove={handleMouseHover}
    >
      <img src={imageUrl} alt="" className="magnifier-img" />

      {showMagnifier && (
        <div
          style={{
            position: 'absolute',
            left: `${position.x - magnifierSize / 2}px`,
            top: `${position.y - magnifierSize / 2}px`,
            width: magnifierSize,
            height: magnifierSize,
            pointerEvents: 'none',
            borderRadius: '1%',
            overflow: 'hidden',
            boxShadow: '1px 1px 8px rgba(0,0,0,0.6)',
          }}
        >
          <div
            className="magnifier-image"
            style={{
              width: '100%',
              height: '100%',
              backgroundImage: `url(${imageUrl})`,
              backgroundSize: `${zoom * 100}%`,
              backgroundPosition: `${position.xPercent}% ${position.yPercent}%`,
              backgroundRepeat: 'no-repeat',
              transform: 'scale(1.01)', // fixes subtle rendering artifacts
            }}
          />
        </div>
      )}
    </div>
  )
}

export default ImageMagnifier
